module.exports = __webpack_public_path__ + "static/description-3-ed8bc481256da8c3864b25844cd41881.png";